// import { User } from "../../../../data/schema/user/user";
// import { Role } from "../../../../data/schema/roles/role";
// import { Module } from '@schema/module/module';

 
 
export class addBreadCrumb {
    static readonly type = '[Breadcrumb] Add';

    constructor(public payload: any) {
    }
}

export class clearAllBreadCrumb {
    static readonly type = '[ClearBreadcrumb] clear';

    constructor() {
    }
}
export class clearBreadCrumb {
    static readonly type = '[ClearBreadcrumbByIndex] clearByIndex';

    constructor(public payload:any) {
    }
}

export class Reset {
    static readonly type = 'Reset';
  }
  
 
 
 